import React, { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Live JSK Blessing Points chip for navbar.
 * Polls /me/points every 20 seconds (lightweight) so the badge updates after
 * background emotion analysis completes on a freshly-posted thread/reply.
 */
export default function PointsBadge() {
  const { user } = useAuth();
  const [points, setPoints] = useState(null);

  useEffect(() => {
    if (!user || user === false) {
      setPoints(null);
      return;
    }
    let cancelled = false;
    const fetchPoints = async () => {
      try {
        const { data } = await api.get("/me/points");
        if (!cancelled) setPoints(data.points || 0);
      } catch {}
    };
    fetchPoints();
    const id = setInterval(fetchPoints, 20000);
    return () => { cancelled = true; clearInterval(id); };
  }, [user]);

  if (!user || user === false || points === null) return null;
  return (
    <Link
      to="/profile"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#F2D8CF] text-[#C05B3B] border border-[#E8B5A6] text-xs font-medium hover:bg-[#EFC9BC] transition-colors"
      data-testid="points-badge"
      title="JSK Blessing Points"
    >
      <Sparkles size={12} />
      <span data-testid="points-badge-value">{points}</span>
      <span className="hidden sm:inline">JSK</span>
    </Link>
  );
}
